export * from "./prescriber.component";
export * from "./prescriber-info/prescriber-info.component";
export * from "./prescriber-tabs/prescriber-tabs.component";
export * from "./prescriber-history/prescriber-history.component";
export * from "./prescriber-search/prescriber-search.component";
